export default function EditIcon({
  width = "32",
  height = "32",
  className = "",
  stroke = "#E4E1EB",
  fill = "#1F2937",
}: {
  width?: string;
  height?: string;
  className?: string;
  stroke?: string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
        fill={fill}
      />
      <path
        d="M17.7157 13.5167L18.4824 14.2833L10.9324 21.8333H10.1657V21.0667L17.7157 13.5167ZM20.7157 8.5C20.5074 8.5 20.2907 8.58333 20.1324 8.74167L18.6074 10.2667L21.7324 13.3917L23.2574 11.8667C23.5824 11.5417 23.5824 11.0167 23.2574 10.6917L21.3074 8.74167C21.1407 8.575 20.9324 8.5 20.7157 8.5ZM17.7157 11.1583L8.49902 20.375V23.5H11.624L20.8407 14.2833L17.7157 11.1583Z"
        fill={stroke}
      />
    </svg>
  );
}
